module.exports = __webpack_public_path__ + "21926f5822101a63c6c5c2a39fc77de7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/AX.svg
// module id = wRH3
// module chunks = 0